import { useMemo } from "react";

import type { UserPermission } from "@js/types/auth";
import { hasPermission } from "@js/utils";

import { useUser } from "../use-user";

export const usePermission = (permission: UserPermission) => {
  const user = useUser();

  return useMemo(() => hasPermission(user, permission), [user, permission]);
};
